<template>
  <div v-if="!!floating" class="floatingBanner" :style="floatingStyle">
    <div class="icon"
      v-for="item in floating.list"
      v-show="item.icon.trim() !== ''"
      :key="item.id"
      :style="style">
      <SetLink
        :linkTarget="item"
        :lang="lang" />
      <img :src="item.icon" alt="" />
    </div>
  </div>
</template>

<script>
import SetLink from '@/components/Util/SetLink.vue'

export default {
  name: 'Floating',
  props: [
    'floating',
    'lang'
  ],
  components: {
    SetLink
  },
  computed: {
    floatingStyle () {
      const style = this.floating.style
      const position = this.floating.position
      const otherPosition = position === 'right' ? 'left' : 'right'
      return {
        ...style && style.positionBottom && {
          bottom: `${style.positionBottom}px`
        },
        ...style && style.positionLeftRight && {
          [position]: `${style.positionLeftRight}px`,
          [otherPosition]: 'auto'
        }
      }
    },
    style () {
      const style = this.floating.style
      return {
        width: `${style.size}px`
      }
    }
  }
}
</script>
